import { combineReducers } from "redux";
import inquiry from "../features/admin/inquiryform/inquiry/Slice";




const inquiryform = combineReducers({
   inquiry: inquiry,
  
  });
  
  export default inquiryform;